export const keyToNameList = {
  fd_code: "FD Code",
  ordered_by: "Ordered By",
  orderer_phone: "Phone Number",
  late_person_name: "Late person`s Name",
  funeral_date: "Funeral Date",
  funeral_time: "Funeral Time",
  tributes_delivery_time: "Tributes Delivery Time",
  funeral_location: "Funeral Location",
  casket_cover_delivery_time: "Casket Cover Delivery Time",
  tribuite_delivery_location: "Tributes Delivery Location",
  casket_cover_delivery_location: "Casket Cover Delivery Location",
  payment_option: "Payment Option",
  payment_email: "Invoice Email",
  price: "Price ($)",
  customPrice: "Custom Price ($)",
  amount: "Amount (Pcs)",
  sash_message: "Sash Message",
  card_message: "Card Message",
  order_message: "Order Comment",
  comment: "Comment",
  name: "Name",
  product_name: "Product Name",
  order_type: "Order Type",
  lidType: "Lid Type",
  product_type: "Product Type",
  size: "Size",
  type: "Type",
  start: "Task Assigned at",
  ended: "Task Ended at",
  checked_1: "First Check",
  checked_2: "Second Check",
  checked_3: "Final Check",
  time_difference: "Time Taken",
  code: "Code",
  image: "Picture",
  content: "Content",
  description: "Description",
  company_name: "Company Name",
  recipient_name: "Recipient`s Name",
  recipient_phone: "Recipient`s Phone",
  delivery_location: "Delivery Location",
  delivery_date: "Delivery Date",
  delivery_day: "Delivery Day",
  delivery_area: "Delivery Area",
  time_of_delivery: "Delivery Time",
  frequency: "Frequency",
  order_start_date: "Order Start On",
  payment_date: "Payment Date",
  invoice_number: "Invoice Number",
};

export const ProductTypes = [
  "Casket cover",
  "Heart",
  "Bowl",
  "Wreath",
  "Sprays",
  "Croatian Tributes",
  "Cross",
  "Letters",
  "Arrangement",
  "Singles/Petals",
  "Small Petals",
  "Large Petals",
  "Singles",
  "Bookspray",
  "Other",
];

export const weekDays = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wendsday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const ThemeColor = [
  "#b79856",
  "hsl(192.21deg 32.53% 67.45%)",
  "hsl(239.62deg 32.53% 67.45%)",
  "hsl(76.54deg 32.53% 67.45%)",
  "hsl(304.23deg 32.53% 67.45%)",
  "hsl(88.85deg 32.53% 67.45%)",
];

export const EaselProducts = [
  "Wreath",
  "Heart",
  "Cross",
  "Sprays",
  "Letters",
  "Board",
];
//dev
// export const BASE_SERVER_URL = "https://rays-florist-api-dev-xjnjc.ondigitalocean.app";

//prod
export const BASE_SERVER_URL = "https://hammerhead-app-2-uaqvn.ondigitalocean.app";

// //
// export const BASE_SERVER_URL = "http://localhost:9999";

export const BASE_SPACE_URL = "https://rfspaces.nyc3.digitaloceanspaces.com/";
//
